import { Text, type TextProps } from '@frontend/components';

export type ResponseParagraphProps = TextProps;

/**
 * Base paragraph component for Response.
 * Provides consistent styling for paragraphs in AI responses.
 */
export const ResponseParagraph = ({
  className,
  children,
  ...props
}: ResponseParagraphProps) => {
  return (
    <Text className={className} wordBreak="break-word" {...props}>
      {children}
    </Text>
  );
};
